var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useIndicatorLayouts } from '../context/indicator-layouts-context';
import { omit } from 'lodash';
import { IndicatorLayoutDefault } from '../indicator-layouts/indicator-layout-default';
import { calculateFlexInfo } from '../utils/calculate-flex-info';
import { indicatorHasValue } from '../utils/indicator-has-value';
var cls = classNames('indicator-group-layout-grid');
var IndicatorGroupLayoutGridDefaultProps = {
  rowWeight: 2,
  rowGapInUnits: 4,
  columnGapInUnits: 3
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(4))
});
var ItemsStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    padding: 0;\n    margin: 0;\n    ", "\n  "], ["\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    padding: 0;\n    margin: 0;\n    ", "\n  "])), function (_a) {
    var columnGap = _a.columnGap,
      rowGap = _a.rowGap;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      column-gap: ", ";\n      row-gap: ", ";\n    "], ["\n      column-gap: ", ";\n      row-gap: ", ";\n    "])), theme.UNIT(columnGap || 0), theme.UNIT(rowGap || 0));
  })
});
var ItemStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: block;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    ", "\n  "], ["\n    display: block;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    ", "\n  "])), function (_a) {
    var weight = _a.weight,
      rowWeight = _a.rowWeight,
      basis = _a.basis;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      flex-basis: ", ";\n    "], ["\n      flex-basis: ", ";\n    "])), basis);
  })
});
// -------- Components -------->
var My = {
  NAME: 'IndicatorGroupLayoutGrid',
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Items: styled.ul(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled.li(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles)
};
export var IndicatorGroupLayoutGrid = function (props) {
  var componentProps = useComponentProps(My.NAME, IndicatorGroupLayoutGridDefaultProps, props);
  var className = componentProps.className,
    entity = componentProps.entity,
    columnGapInUnits = componentProps.columnGapInUnits,
    rowGapInUnits = componentProps.rowGapInUnits;
  var indicatorLayouts = useIndicatorLayouts();
  var indicators = entity.indicators.filter(indicatorHasValue);
  var indicatorCount = indicators.length;
  var effectiveRowWeight = Math.min(componentProps.rowWeight, indicatorCount);
  var indicatorsWithWeights = entity.indicators.map(function (indicator) {
    var _a;
    return __assign(__assign({}, indicator), {
      weight: ((_a = indicator.layout) === null || _a === void 0 ? void 0 : _a.weight) || 1
    });
  });
  var indicatorsWithFlexInfo = calculateFlexInfo(indicatorsWithWeights, effectiveRowWeight, columnGapInUnits * 4);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Items, {
    columnGap: columnGapInUnits,
    rowGap: rowGapInUnits
  }, indicatorsWithFlexInfo.map(function (indicator, index) {
    var _a;
    var flexInfo = indicator.flexInfo;
    var Layout = indicatorLayouts[(_a = indicator.layout) === null || _a === void 0 ? void 0 : _a.component] || IndicatorLayoutDefault;
    return React.createElement(My.Item, {
      key: indicator.id,
      basis: flexInfo.basis,
      weight: flexInfo.effectiveWeight,
      rowWeight: effectiveRowWeight
    }, React.createElement(Layout, {
      key: index,
      entity: omit(indicator, 'flexInfo')
    }));
  })));
};
IndicatorGroupLayoutGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;